module.exports = __webpack_public_path__ + "img/logo4.2be6a2e5.svg";